import React, { useEffect, useState } from "react";
import api, { formatTanggal } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_KEPSEK } from "@/lib/nav";

export default function SaranKritik() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/saran-kritik"); setItems(data); }
      catch (e) { console.error("Load saran-kritik failed:", e); }
    })();
  }, []);
  return (
    <Layout nav={NAV_KEPSEK}>
      <PageTitle title="Saran dan Kritik Orangtua" />
      <section className="pp-card overflow-hidden">
        <table className="w-full text-sm" data-testid="sk-table">
          <thead><tr className="pp-table-header">
            <th className="text-left px-5 py-3">Nama Siswa</th>
            <th className="text-left px-5 py-3">Tanggal</th>
            <th className="text-left px-5 py-3">Isi</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={3} className="text-center py-10 text-slate-400 italic">Belum ada saran/kritik.</td></tr>}
            {items.map(s => (
              <tr key={s.id} className="pp-row">
                <td className="px-5 py-3 font-medium">{s.nama_siswa}</td>
                <td className="px-5 py-3 text-xs text-slate-500">{formatTanggal(s.created_at)}</td>
                <td className="px-5 py-3 text-slate-700 whitespace-pre-wrap">{s.isi}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </Layout>
  );
}
